export default __webpack_public_path__ + "static/media/brittanyBroskiNFT.58bf78c6.mp4";